import Textfield from '@components/Textfield'

const maxSize = 5 * 1024 * 1024
const fileTypes = ['gif', 'png', 'jpg', 'jpeg', 'pdf', 'txt', 'doc', 'docx']

const FileUploader = ({ onFileSelectSuccess, onFileSelectError }) => {
    const fileInput = React.useRef(null)
    const [selectedFile, setSelectedFile] = React.useState(null)

    const handleFileInput = event => {
        event.preventDefault()

        const file = event.target.files[0]
        if (file) setSelectedFile(file)
        const fileType = file.name.toLowerCase().split('.').pop()

        if (fileTypes.indexOf(fileType) === -1) {
            onFileSelectError('feedback.attachment.type.error')
        } else if (file.size > maxSize) {
            onFileSelectError('feedback.attachment.size.error')
        } else {
            onFileSelectError('')
            const reader = new FileReader()
            reader.onload = () => onFileSelectSuccess(`${file.name.toLowerCase()};${reader.result}`)

            reader.readAsDataURL(file)
        }
    }

    return (
        <>
            <input
                type="file"
                ref={fileInput}
                onChange={handleFileInput}
                className="d-none"
                accept={fileTypes.map(type => `.${type}`).join(', ')}
            />
            <Textfield
                label={selectedFile ? selectedFile.name.replace(/^.*\\/, '') : <T>feedback.attachment.label</T>}
                type="button"
                title="File Upload"
                className={selectedFile ? 'selected-file' : ''}
                onClick={() => fileInput.current && fileInput.current.click()}
            />
        </>
    )
}

export default FileUploader
